import { AfterViewInit, Component, ElementRef, EventEmitter, HostListener, Input, NgZone, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { fromEvent, Subscription } from 'rxjs';
import { concatMap, map, pairwise, switchMap, takeUntil, tap } from 'rxjs/operators';
import { LoggerService } from '../providers/logger.service';
import { TwfstyleService } from '../providers/twfstyle.service';

@Component({
  selector: 'app-canvas-editor',
  template: `<div #abxElementWrapper><canvas #abxElement></canvas><div id='listener' [ngStyle]='listenerStyle'></div></div>`,
  styles: [
  ]
})

export class CanvasEditorComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() option: any;
  @Input() active: boolean;
  @Input() inkColor: any;
  @Input() inkWidth: any;
  @Input() backgroundId: string;
  @Input() initialPoints: any[];
  @Input() refresh: any;
  @Output() updatePoints: EventEmitter<any> = new EventEmitter();
  @Output() abxOnDrawStart: EventEmitter<any> = new EventEmitter();
  @Input() fromSignatureDialog: boolean = false;
  @Input() container: string = '';
  @Input() mode: string = '';
  @Input() isSigDialog: boolean = false;
  lineCap: string = 'round';
  lineJoin: string = 'round';

  MODE_INSERTING_PEN_START = 'insertingPenStart';
  MODE_INSERTING_PEN = 'insertingPen';
  MODE_INSERTING_MARKER_START = 'insertingMarkerStart';
  MODE_INSERTING_MARKER = 'insertingMarker';

  mouseDown = false;
  currentLine = [];
  allLines = [];

  lastPoint = { x: -10, y: -10 };
  curveEnd = { x: -10, y: -10 };

  path = undefined;
  allPaths = [];

  scale = undefined;
  bgcanvas = undefined;

  listenerStyle = { position: "absolute", top: "0px", left: "0px", "z-index": 2000 };

  @ViewChild("abxElement", { static: false }) abxElement: ElementRef;
  @ViewChild("abxElementWrapper", { static: false }) abxElementWrapper: ElementRef;
  cx;
  canvas: any; //= { width: 500, height: 500 };
  currentLocation = { x: 200, y: 200 };
  preDirection: string;
  drawingSubscription: Subscription;

  locationList = [];

  /**
   * HostListeners 
   */

  //@HostListener('document:mousedown', ['$event'])
  //pressMouseEventHandler(event: MouseEvent) {
  //  if ((event.target && event.target['id'] === 'listener')) {
  //    this.handleMouseDown(event);
  //  }
  //}

  //@HostListener('document:touchstart', ['$event'])
  //pressTouchEventHandler(event: TouchEvent) {
  //  if ((event.touches && event.touches[0].target && event.touches[0].target['id'] === 'listener')) {
  //    this.handleMouseDown(event);
  //  }
  //}

  //@HostListener('document:mousemove', ['$event'])
  //mouseDragEventHandler(event: MouseEvent) {
  //  this.handleMouseMove(event);
  //}

  //@HostListener('document:touchmove', ['$event'])
  //touchDragEventHandler(event: TouchEvent) {
  //  this.handleMouseMove(event);
  //}

  //@HostListener('document:mouseup', ['$event'])
  //mouseReleaseEventHandler(event: MouseEvent) {
  //  this.handleMouseUp(event);
  //}

  //@HostListener('document:touchend', ['$event'])
  //touchReleaseEventHandler(event: TouchEvent) {
  //  this.handleMouseUp(event);
  //}

  //@HostListener('document:mouseout', ['$event'])
  //mouseOutEventHandler(event: MouseEvent) {
  //  if (this.mouseDown) this.handleMouseUp(event);
  //}

  //@HostListener('document:touchout', ['$event'])
  //touchOutEventHandler(event: TouchEvent) {
  //  if (this.mouseDown) this.handleMouseUp(event);
  //}

  touchEvents = 'ontouchstart' in document.documentElement;

  constructor(private logger: LoggerService,
    private ngZone: NgZone,
    private twfStyle: TwfstyleService,
    private elementRef: ElementRef) {
  }


  ngOnChanges(changes: SimpleChanges): void {
    try {
      if (this.cx) {
        if (this.initialPoints && this.initialPoints.length === 0) {
          this.allPaths = [];
          this.redrawCanvas();
        }

        if (('inkColor' in changes && changes['inkColor'].currentValue !== changes['inkColor'].previousValue) || ('inkWidth' in changes && changes['inkWidth'].currentValue !== changes['inkWidth'].previousValue)) {
          this.changeCavasSettings();
        }

        if ('refresh' in changes && this.container === 'penSigContainer') {
          this.drawPath(this.initialPoints);
        }
      }
    } catch (e) {
      this.logger.logInternalError("CANVAS EDITOR: $onChanges", e.message);
    }
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {

    this.abxElementWrapper.nativeElement.addEventListener('pointerdown', (e) => {
      if ((e.target && e.target['id'] === 'listener') && !this.touchEvents) {
        this.handleMouseDown(e);
      }
    }, { passive: false });

    this.abxElementWrapper.nativeElement.addEventListener('touchstart', (e) => {
      if ((e.touches && e.touches[0].target && e.touches[0].target['id'] === 'listener')) {
        this.handleMouseDown(e);
      }
    }, { passive: false });

    this.abxElementWrapper.nativeElement.addEventListener('pointermove', (e) => {
      if ((e.target && e.target['id'] === 'listener') && !this.touchEvents) {
        this.handleMouseMove(e);
      }
    }, { passive: false });

    this.abxElementWrapper.nativeElement.addEventListener('touchmove', (e) => {
      if ((e.touches && e.touches[0].target && e.touches[0].target['id'] === 'listener')) {
        this.handleMouseMove(e);
      }      
    }, { passive: false });

    this.abxElementWrapper.nativeElement.addEventListener('pointerup', (e) => {
      if (this.mouseDown) this.handleMouseUp(e);
    }, { passive: false });

    const canvasEl: HTMLCanvasElement = this.abxElement.nativeElement;
    this.cx = canvasEl.getContext('2d');

    // set the width and height
    if (document.getElementById(this.container)) {
      if (this.container === 'penSigContainer') {
        canvasEl.width = document.getElementById(this.container).offsetWidth - 2;
        canvasEl.height = document.getElementById(this.container).offsetHeight - 2;
      } else {
        canvasEl.width = document.getElementById(this.container).offsetWidth;
        canvasEl.height = document.getElementById(this.container).offsetHeight;
      }
    }

    if (this.mode === this.MODE_INSERTING_PEN || this.mode === this.MODE_INSERTING_PEN_START) {
      this.lineCap = 'round';
    } else if (this.mode === this.MODE_INSERTING_MARKER || this.mode === this.MODE_INSERTING_MARKER_START) {
      this.lineCap = 'square';
    }

    if (document.getElementById('listener')) {
      document.getElementById('listener').style.width = canvasEl.width + 'px';
      document.getElementById('listener').style.height = canvasEl.height + 'px';
    }
    // set some default properties about the line
    this.cx.lineWidth = this.inkWidth;
    this.cx.lineCap = this.lineCap;
    this.cx.strokeStyle = this.twfStyle.toCssColor(this.inkColor);

    this.canvas = canvasEl;
    this.clearCanvas();
  }  

  changeCavasSettings() {
    const canvasEl: HTMLCanvasElement = this.abxElement.nativeElement;
    this.cx = canvasEl.getContext('2d');

    this.cx.lineWidth = this.inkWidth;
    this.cx.lineCap = this.lineCap;
    this.cx.strokeStyle = this.twfStyle.toCssColor(this.inkColor);

    var img = document.getElementById(this.backgroundId) as HTMLImageElement;
    this.cx.drawImage(img, 0, 0, img.width, img.height);
    this.cx.lineWidth = this.inkWidth;
    this.cx.strokeStyle = this.twfStyle.toCssColor(this.inkColor);
    if (this.initialPoints) {
      let arrInitialPoints = [];

      for (var i = 0; i < this.initialPoints.length; i++) {
        arrInitialPoints.push(this.initialPoints[i]);
      }
      
      this.drawPath(arrInitialPoints);
    }
  }

  getScale() {
    if (this.scale !== undefined) return this.scale;

    var scale = 1;
    //var transform = window.getComputedStyle(this.elementRef.nativeElement.parentElement).transform;
    var transform = document.getElementById("page").style.transform;
    if (transform !== undefined) {
      if (transform.startsWith("scale(")) {
        var ttransform = transform.substring(7).split(",");
        scale = parseFloat(ttransform[0]);
      }
    }
    this.scale = scale;
    return scale;
  }

  getOffsetX(ev) {
    var scale = this.getScale();
    var rect = this.canvas.getBoundingClientRect();
    if (this.isSigDialog) {
      return (ev.touches[0].clientX - rect.left)
    } else {
      return (ev.touches[0].clientX - rect.left) / scale;
    }
    //return (ev.touches[0].clientX - rect.left) /*/ scale*/;
  }

  getOffsetY(ev) {
    var scale = this.getScale();
    var rect = this.canvas.getBoundingClientRect();
    if (this.isSigDialog) {
      return (ev.touches[0].clientY - rect.top)
    } else {
      return (ev.touches[0].clientY - rect.top) / scale;
    }
    //return (ev.touches[0].clientY - rect.top) /*/ scale*/;
  }

  clearCanvas() {
    var img = document.getElementById(this.backgroundId) as HTMLImageElement;
    this.cx.drawImage(img, 0, 0, img.width, img.height);
    this.cx.lineWidth = this.inkWidth;
    this.cx.strokeStyle = this.twfStyle.toCssColor(this.inkColor);
    this.allPaths.map((path) => { this.cx.stroke(path); });
    if (this.initialPoints.length !== 0) {
      this.drawPath(this.initialPoints);
    }
  }

  drawPath(path) {
    try {
      if (path.length < 8) return;

      var bPath = new Path2D();

      var px = path[0];
      var py = path[1];

      for (var i = 0; i < path.length; i = i + 8) {

        if (i === 0)
          bPath.moveTo(px, py);
        else if (px !== path[i] || py !== path[i + 1])
          bPath.moveTo(path[i], path[i + 1]);

        bPath.bezierCurveTo(path[i + 2], path[i + 3], path[i + 4], path[i + 5], path[i + 6], path[i + 7]);
        px = path[i + 6];
        py = path[i + 7];
      }

      this.cx.stroke(bPath);
    }
    catch (e) {
      this.logger.logInternalError('CanvasEditor.drawPath', e.message);
    }
  }

  redrawCanvas() {
    this.clearCanvas();
    if (this.path) {
      this.cx.stroke(this.path);
    }
  }

  handleMouseDown(ev) {
    try {
      if (!this.active) return;

      var evtX = this.touchEvents ? this.getOffsetX(ev) : ev.offsetX;
      var evtY = this.touchEvents ? this.getOffsetY(ev) : ev.offsetY;

      /*if (!this.touchEvents)*/
      ev.preventDefault();
      ev.stopPropagation();

      this.currentLine = [];
      this.mouseDown = true;

      this.cx.lineWidth = this.inkWidth;
      this.cx.strokeStyle = this.twfStyle.toCssColor(this.inkColor);
      this.cx.lineCap = this.lineCap;
      this.cx.lineJoin = this.lineJoin;

      this.lastPoint.x = evtX;
      this.lastPoint.y = evtY;
      this.curveEnd.x = evtX;
      this.curveEnd.y = evtY;
      this.currentLine.push(evtX);
      this.currentLine.push(evtY);

      // Create path
      this.path = new Path2D();

      // Move path to initial position (position of the cursor)
      this.path.moveTo(evtX, evtY);

      // Add point to the path
      this.path.bezierCurveTo(evtX, evtY, evtX, evtY, evtX + 1, evtY);
      this.currentLine.push(evtX + 1);
      this.currentLine.push(evtY);
      this.redrawCanvas();

      ev.preventDefault();
      ev.stopPropagation();

      if (this.abxOnDrawStart) this.abxOnDrawStart.emit();
    } catch (e) {
      this.logger.logInternalError("CANVAS EDITOR: mouseDown", e.message);
    }
  }

  handleMouseUp(ev) {
    try {
      if (!this.active) return;
      //if (!this.touchEvents)

      if (!this.mouseDown) return;
      this.mouseDown = false;

      var curve = [];
      if (this.currentLine.length > 2) {
        curve = this.smoothCurve(this.currentLine);
        this.allLines = this.allLines.concat(curve);
        this.currentLine = [];
      } else {
        this.currentLine = [];
      }

      if (this.path !== undefined) this.allPaths.push(this.path);
      this.updatePoints.emit({ points: curve });
      this.path = undefined;

      ev.preventDefault();
      ev.stopPropagation();

    } catch (e) {
      this.logger.logInternalError("CANVAS EDITOR: mouseUp", e.message);
    }
  }

  handleMouseMove(ev) {
    try {
      if (!this.active) return;

      if (this.mouseDown) {
        /*if (!this.touchEvents)*/

        var evtX = this.touchEvents ? this.getOffsetX(ev) : ev.offsetX;
        var evtY = this.touchEvents ? this.getOffsetY(ev) : ev.offsetY;

        if (Math.abs(this.lastPoint.x - evtX) < 2 && Math.abs(this.lastPoint.y - evtY) < 2) return;

        var c1 = this.middlePoint([this.curveEnd.x, this.curveEnd.y], [this.lastPoint.x, this.lastPoint.y]);
        var E = this.middlePoint([this.lastPoint.x, this.lastPoint.y], [evtX, evtY]);
        this.curveEnd.x = E[0];
        this.curveEnd.y = E[1];
        var c2 = this.middlePoint([this.lastPoint.x, this.lastPoint.y], [this.curveEnd.x, this.curveEnd.y]);
        this.path.bezierCurveTo(c1[0], c1[1], c2[0], c2[1], this.curveEnd.x, this.curveEnd.y);

        this.redrawCanvas();

        this.lastPoint.x = evtX;
        this.lastPoint.y = evtY;
        this.curveEnd.x = evtX;
        this.curveEnd.y = evtY;

        this.currentLine.push(evtX);
        this.currentLine.push(evtY);

        ev.preventDefault();
        ev.stopPropagation();
      }
    } catch (e) {
      this.logger.logInternalError("CANVAS EDITOR: mouseMove", e.message);
    }
  }

  middlePoint(P1, P2) {
    return [(P1[0] + P2[0]) / 2, (P1[1] + P2[1]) / 2];
  }

  smoothCurve(curve) {

    try {
      var smoothCurve = [];

      var P1 = [curve[0], curve[1]];
      var M = [curve[2], curve[3]];
      M = this.middlePoint(P1, M);

      smoothCurve = [P1[0], P1[1], P1[0], P1[1], P1[0], P1[1], M[0], M[1]];

      for (var i = 2; i < curve.length - 3; i += 2) {
        var curr = [curve[i], curve[i + 1]];
        var next = [curve[i + 2], curve[i + 3]];
        var c1 = this.middlePoint(M, curr);
        var end = this.middlePoint(curr, next);
        var c2 = this.middlePoint(curr, end);
        smoothCurve.push(M[0], M[1], c1[0], c1[1], c2[0], c2[1], end[0], end[1]);
        M = end;
      }

      P1 = [curve[curve.length - 2], curve[curve.length - 1]];
      smoothCurve.push(M[0], M[1], P1[0], P1[1], P1[0], P1[1], P1[0], P1[1]);

      return smoothCurve;
    } catch (e) {
      this.logger.logInternalError("CANVAS EDITOR: curve", e.message);
      console.log("ERROR: " + e.message);
      return undefined;
    }
  }
}
